import React, { ReactElement, ReactNode } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WrapperToastContent } from './styles';

interface ToastProps {
  children: ReactNode;
  type: string;
}

const ToastComponent: React.FC<ToastProps> = ({ children }): ReactElement => (
  <WrapperToastContent>
    <p>{children}</p>
  </WrapperToastContent>
);

const successToast = (message: string, options = {}): React.ReactText =>
  toast.success(<ToastComponent type="success">{message}</ToastComponent>, {
    ...options,
    autoClose: 8000,
  });

const warnToast = (message: string, options = {}): React.ReactText =>
  toast.warn(<ToastComponent type="warning">{message}</ToastComponent>, {
    ...options,
    autoClose: 8000,
  });

const errorToast = (message: string, options = {}): React.ReactText =>
  toast.error(<ToastComponent type="error">{message}</ToastComponent>, {
    ...options,
    autoClose: 8000,
  });

export { successToast, errorToast, warnToast };
